import React, { useRef, useLayoutEffect, useState } from "react";
import Nav from "../ui/Nav";
import Status from "../ui/Status";
import { InfoIcon } from "../utils/Icons";
import TextButton from "../ui/TextButton";
import { kbdEvent } from "../utils/Utils";
import { KBD } from "../utils/Keybindings";

export default function FocusWrap({
    active = false,
    message = "",
    children,
    mask_close = true,
    mask = true,
    onClose = () => { },
    onSave = false,
    close = true,
    save = true,
    style = {height : "100%"},
}) {
    const ref = useRef(null);
    const [rect, setRect] = useState(null);

    useLayoutEffect(() => {
        if (!active || !ref.current) return;

        const update = () => {
            const r = ref.current.getBoundingClientRect();
            setRect(r);
        };

        update();
        window.addEventListener("scroll", update, true);
        window.addEventListener("resize", update);

        return () => {
            window.removeEventListener("scroll", update, true);
            window.removeEventListener("resize", update);
        };
    }, [active]);


    const handleBackgroundClick = (e) => {

        if (mask_close) {
            kbdEvent(KBD.ESCAPE);
        }

        onClose();
    };


    const handleSave = () => {

        if(onSave){
            onSave()
        } else {
            kbdEvent(KBD.PAGE_DOWN)
        }
    }

    return (
        <>
            <div style={{...style}} ref={ref}>
                {children}
            </div>

            {active && rect && (
                <>
                    {mask && (
                        <>
                            {/* top */}
                            <div
                                className="focus-dim"
                                onClick={handleBackgroundClick}
                                style={{
                                    top: 0,
                                    left: 0,
                                    width: "100vw",
                                    height: rect.top,
                                }}
                            />

                            {/* bottom */}
                            <div
                                className="focus-dim"
                                onClick={handleBackgroundClick}
                                style={{
                                    top: rect.bottom,
                                    left: 0,
                                    width: "100vw",
                                    height: `calc(100vh - ${rect.bottom}px)`,
                                }}
                            />

                            {/* left */}
                            <div
                                className="focus-dim"
                                onClick={handleBackgroundClick}
                                style={{
                                    top: rect.top,
                                    left: 0,
                                    width: rect.left,
                                    height: rect.height,
                                }}
                            />

                            {/* right */}
                            <div
                                className="focus-dim"
                                onClick={handleBackgroundClick}
                                style={{
                                    top: rect.top,
                                    left: rect.right,
                                    width: `calc(100vw - ${rect.right}px)`,
                                    height: rect.height,
                                }}
                            />
                        </>
                    )}

                    {/* outline */}
                    <div
                        className="focus-outline"
                        onClick={(e) => e.stopPropagation()}
                        style={{
                            top: rect.top,
                            left: rect.left,
                            width: rect.width,
                            height: rect.height,
                        }}
                    />

                    {/* menu */}
                    {(close || save || message) && (
                        <div
                            className="focus-menu"
                            onClick={(e) => e.stopPropagation()}
                            style={{
                                top: rect.bottom + 6,
                                left: rect.left,
                            
                            }}
                        >
                            <Status  type="active">
                                {(close && <TextButton onClick={() => kbdEvent(KBD.ESCAPE)} style={{ "height": "19px", "lineHeight": "20px", "fontSize": "13px" }}>Cancel</TextButton>)}
                                {(save && <TextButton onClick={() => handleSave()} style={{ "height": "19px", "lineHeight": "20px", "fontSize": "13px" }}>Save</TextButton>)}
                                {message}</Status>



                        </div>
                    )}
                </>
            )}
        </>
    );
}
